import type { Modifier, Modifiers } from 'react-day-picker';

import type { SingleDatePickerBodyProps } from '.';

export const singleDatePickerModifiers = {
  defineSelectedDays: ({
    hoveredDate,
  }: Partial<SingleDatePickerBodyProps>): Modifier => {
    if (hoveredDate) {
      return hoveredDate.toDate();
    }

    return undefined;
  },

  defineModifiers: ({
    selectedDate,
    modifiers,
  }: SingleDatePickerBodyProps): Partial<Modifiers> => {
    if (selectedDate) {
      return { current: selectedDate.toDate(), ...modifiers };
    }
    return { ...modifiers };
  },
};
